export type MemberFieldDef = {
  key: string;
  label: string;
  group: 'member' | 'address';
  required?: boolean;
  inputType?: 'text' | 'date' | 'email' | 'tel' | 'select';
};

export const MEMBER_FIELDS = [
  {key: 'firstName', label: 'First Name', group: 'member', required: true},
  {key: 'lastName', label: 'Last Name', group: 'member', required: true},
  {key: 'middleName', label: 'Middle Name', group: 'member'},
  {key: 'ssn', label: 'SSN', group: 'member', required: true},
  {key: 'dateOfBirth', label: 'Date of Birth', group: 'member', required: true, inputType: 'date'},
  {key: 'sexCode', label: 'Gender', group: 'member', inputType: 'select'},
  {key: 'email', label: 'Email', group: 'member', inputType: 'email'},
  {key: 'phone', label: 'Phone', group: 'member', inputType: 'tel'},
  {key: 'employeeId', label: 'Employee ID', group: 'member'},
  {key: 'hireDate', label: 'Hire Date', group: 'member', inputType: 'date'},
  {key: 'street', label: 'Address 1', group: 'address'},
  {key: 'street2', label: 'Address 2', group: 'address'},
  {key: 'city', label: 'City', group: 'address'},
  {key: 'state', label: 'State', group: 'address', inputType: 'select'},
  {key: 'zip', label: 'Zip', group: 'address'},
] as const satisfies readonly MemberFieldDef[];

export type MemberFieldKey = (typeof MEMBER_FIELDS)[number]['key'];

export const MEMBER_ONLY_FIELDS = MEMBER_FIELDS.filter((f) => f.group === 'member');
export const ADDRESS_ONLY_FIELDS = MEMBER_FIELDS.filter((f) => f.group === 'address');

export const MEMBER_FIELD_LABELS = MEMBER_FIELDS.map((f) => f.label);

export const REQUIRED_MEMBER_LABELS = MEMBER_FIELDS.filter((f) => f.required).map((f) => f.label);

export function getLabelForKey(key: string): string {
  return MEMBER_FIELDS.find((f) => f.key === key)?.label ?? key;
}
